import locale from 'init/locale'
import { View } from 'es6/components/view'
import { Defaults } from 'es-decorators'
import { CommonCityPhoneView } from 'es6/views/common-city-phone-view'
import { LOCALES } from 'es6/constants'

/**
 * Вид для футера
 */

@Defaults({
  el: 'footer',
  additionalOptions: ['disableContactsBlock'],
})
export class FooterView extends View {
  /**
   * @inheritDoc
   */
  run () {
    let waitUralWeb
    this.addUrlParamsToLinks('footer a', { from_footer: '1' })
    this.childViews.phoneView = new CommonCityPhoneView({
      el: '#footer_phone',
      settlement: this.settlement,
    })
    if (this.disableContactsBlock) {
      this.$('.with-icon_clock-blue').addClass('not_display')
      this.$('.phone').addClass('not_display')
      this.$('.address').addClass('not_display')
      this.$('address').addClass('not_display')
    }

    if (locale === LOCALES.ru) {
      waitUralWeb = setInterval(() => {
        if (this.$('#uralweb-hc').length) {
          this.uralwebTargetBlank()
          clearInterval(waitUralWeb)
        }
      }, 500)
    }
  }
  /**
   * Обработка ссылки в виджете UralWeb
   */
  uralwebTargetBlank () {
    this.$('.i-uralweb a').attr('target', '_blank')
  }
}
